import store from "@/store";
import CharacterIntro from '@/components/game/scenes/CharacterIntro';
import StatusMeters from '@/components/game/sidebar/StatusMeters';

export default [
	{
		path: 'intros/enzo',
		components: {
			gameSpace: CharacterIntro,
			sidebar: StatusMeters,
		},
		props: {
			gameSpace: () => ({
				character: "Enzo",
				...store.state.global.api.data.ui.intros.enzo,
			}),
		},
	},
	{
		path: 'intros/bunny',
		components: {
			gameSpace: CharacterIntro,
			sidebar: StatusMeters,
		},
		props: {
			gameSpace: () => ({
				character: "Bunny",
				...store.state.global.api.data.ui.intros.bunny,
			}),
		},
	},
	{
		path: 'intros/next',
		async beforeEnter(to, from, next) {
			const path = from.path === "/game/intros/enzo" ? "/game/intros/bunny" : "/tutorial/start";
			next({ path });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/intros.routes.js